<script>

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';

//components
import AuditLogs from '@/components/Core/AuditLog/AuditLogs.vue'

export default {
	setup() {
		
	},
	name: 'AuditLogList',
	mixins: [ MixinGeneralFunct ],
	components: {
		AuditLogs
	},
	props: ["auth","secData","params"],
	data() {
		return {
			
		}
	},
	
	mounted:function(){
	
	},
	
	methods: {
			
	},	
	
			
	watch: {
	
	},

	computed:{
		
	},
	
}

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
			
		<AuditLogs :auth="auth" :secData="secData" currentDoc="" typeId="" docId="all" ></AuditLogs>
	</div>
		
</template>


